<template>
  <div>
    <div class="action-buttons">
      <Button
        :label="t('Conectar nova conta')"
        icon="pi pi-plus"
        data-testid="instagram-accounts-add-btn"
        @click="handleNew"
      />
    </div>

    <instagram-accounts-table
      ref="tableRef"
      @edit-instagram-account="handleEdit">
    </instagram-accounts-table>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import { eventBus } from '../../eventBus';
import { log } from '../../utils/DebugLogger';
import { useInstagramAccounts } from '../../composables/useInstagramAccounts';
import InstagramAccountsTable from './InstagramAccountsTable.vue';

type Id = number | string;

interface DataTableInstance {
  loadData: () => void;
}

interface AuthUrlResponse {
  auth_url?: string;
}

const { t } = useI18n();
const { getAuthUrl } = useInstagramAccounts();
const tableRef = ref<DataTableInstance | null>(null);

const handleNew = async (): Promise<void> => {
  log('InstagramAccountsPage', 'handleNew', 'Starting OAuth flow');
  try {
    const data = await getAuthUrl() as AuthUrlResponse | null;
    if (data?.auth_url) window.location.href = data.auth_url;
  } catch (err) {
    eventBus.emit('globalMessage.error', t('Erro ao iniciar autenticação Instagram'));
  }
};

const handleEdit = (instagramAccountId: Id): void => {
  log('InstagramAccountsPage', 'handleEdit', 'Opening modal for edit', instagramAccountId);
  eventBus.emit('modal.instagram-accounts.open', { id: instagramAccountId });
};

const handleRefresh = (): void => {
  tableRef.value?.loadData();
};

onMounted(() => {
  eventBus.on('instagram-accounts.refresh', handleRefresh);
});

onBeforeUnmount(() => {
  eventBus.off('instagram-accounts.refresh', handleRefresh);
});
</script>

<style scoped>
.action-buttons {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}
</style>
